
const checkUser = (userCredentials) => {
    const checkedCredentials = userCredentials.filter((item, i) => item.content.trim() === "")
    const result = checkedCredentials.length === 0 ? false : true
    return {result: result, checkedArray: checkedCredentials}
}
export default checkUser;